import PlaceholderBackground from '../../mixins/placeholder-background'

export default {

  mixins: [PlaceholderBackground],
  
  props: {
    heroClass: { type: String, default: '' }, 
    skew: { type: Boolean, default: true },
    placeholderBg: { type: Boolean, default: true },
    imageCollection: { type: Object /*ImageCollection*/ },
    medium: { type: Boolean },
    large: { type: Boolean },
    seed: { type: Number }, // used to seed PlaceholderBackground mixin
    pullContentAbove: { type: Boolean }, // Suck up content below over the header
  },

  computed: {
    classes() {
      return {
        'page-hero--large': this.large,
        'page-hero--medium': this.medium,
        'page-hero--pull-content-above': this.pullContentAbove,
        'block-clipped': this.skew,
        [this.placeholder]: this.placeholderBg,
        [this.heroClass]: true
      }
    },
  },
}